import React from "react";
import { BookmarkIcon, ClockIcon, RefreshCwIcon, UsersIcon } from "lucide-react";
import { Accent, Container, SectionHeader } from "./ui";
import { problems } from "../data/content";
const icons = {
  clock: ClockIcon,
  bookmark: BookmarkIcon,
  users: UsersIcon,
  refresh: RefreshCwIcon
};
export function ProblemsSection() {
  return <section className="bg-cream py-12 md:py-24" data-id="element-158" data-mp="36muo69c6hxro">
      <Container data-id="element-159" data-mp="2sod2eh5u2vce">
        <SectionHeader eyebrow="Sound familiar?" title={<>
              The shift ends. <Accent data-id="element-161" data-mp="2xpkbcjjpq0kn">Tomorrow’s plan</Accent> doesn’t.
            </>} lead="Most activity professionals know these moments well." data-id="element-160" data-mp="2snuvmqljoyq8" />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-162" data-mp="2npjrmwhxlifx">
          {problems.map(p => {
          const Icon = icons[p.icon];
          return <article key={p.title} className="flex h-full flex-col rounded-2xl border border-line bg-white p-6 shadow-[0_10px_30px_rgba(22,78,85,0.06)]" data-id="element-163" data-mp="gxislcwfudlf">
                <span className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-sage text-petrol" data-id="element-164" data-mp="1d7d831ahgrph">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-165" data-mp="1rwrgo768j53t" />
                </span>
                <h3 className="font-display text-[26px] font-bold uppercase leading-none text-petrol" data-id="element-166" data-mp="1mxexbwekog5z">{p.title}</h3>
                <p className="mt-3 text-base text-muted" data-id="element-167" data-mp="z6snq0ox6ntv">{p.description}</p>
              </article>;
        })}
        </div>
        <p className="mx-auto mt-12 max-w-[640px] text-center font-display text-[28px] font-bold uppercase leading-tight text-ink md:text-[32px]" data-id="element-168" data-mp="ua2bxpk5eee9">
          What’s missing isn’t ideas. It’s the <Accent data-id="element-169" data-mp="145vv3rsdh650">materials and the script</Accent> in one place.
        </p>
      </Container>
    </section>;
}